<template>
    <div class="col-md-6" v-if="data && data.length">
         <label for>{{ index + 2 }}. {{ item.title }}</label>
          <select name id v-on:change="$emit('selection', $event)">
              <option>-- {{ label_select }} --</option>
               <option
                v-for="(item, index) in data"
                :value="item.specificationPropertyMasterDataId"
                :key="item.specificationPropertyMasterDataId"
              >{{ item.title }}</option>
          </select>
    </div>
</template>

<script>


export default {
    name: "reconfigureItem",
    props: {
        item: Object,
        index: Object,
        data: Object,
        label_select: {
          type: String,
          required: true,
          default: "select"
        },
    }
};
</script>
